import { Toggle } from "../../../shared/components/Toggle";

customElements.define(
	"esc-hotel-travel-data-toggle",
	class extends Toggle {
		connectedCallback() {
			super.connectedCallback();
			this.toggable
				.querySelector("esc-calendar-input")
				.addEventListener("DialogClosed", this.close.bind(this));
			this.toggable
				.querySelector("esc-guest-selector-input")
				.addEventListener("DialogClosed", this.close.bind(this));
		}
	},
);
